import { FlexGap } from "@magnetic/flex";
import { Info } from "@magnetic/icons";
import { Tooltip } from "@magnetic/tooltip";

import RequiredFieldMarker from "src/components/requiredFieldMarker";
import { clx } from "src/utils/cssUtils";

import { withShowToggle } from "./hoc/withShowToggle";
import { HFlex } from "./hFlex";
import { VFlex } from "./vFlex";

import "./labelFieldContainer.scss";

type LabelSize = "sm" | "md" | "lg";
interface LabelFieldContainerProps {
  readonly name: string; // used for qa tag
  readonly label: string;
  readonly children: React.ReactElement;
  readonly size?: LabelSize;
  readonly required?: boolean;
  readonly className?: string;
  readonly tooltip?: string;
  readonly gap?: FlexGap;
}

export const LabelFieldContainer = withShowToggle(
  (props: LabelFieldContainerProps) => {
    const {
      label,
      children,
      name,
      size = "sm",
      required = false,
      className,
      tooltip,
      gap = "xs"
    } = props;
    return (
      <VFlex
        id={name}
        className={clx("cnc-label-field-container", className)}
        gap={gap}
        data-qa={`label-field-container-for-${name}`}
      >
        <HFlex align="center" gap="xs" className={`label ${size}`}>
          <span>
            {label}
            {required && <RequiredFieldMarker />}
          </span>
          {tooltip && (
            <Tooltip title={tooltip}>
              <Info size={12} weight="bold" />
            </Tooltip>
          )}
        </HFlex>
        {children}
      </VFlex>
    );
  }
);
